import { createContext, useContext } from "react";
import { ITaskOverview, ITaskTemplate } from "models/tasks";
import { UpdateTaskOverviewSignature } from "./useTaskOverview";

export interface ITaskContext {
    task: ITaskOverview | null,
    template: ITaskTemplate | null,
    btnContainer?: () => HTMLElement | null,
    updateTaskOverview: UpdateTaskOverviewSignature,
    refreshTemplate: () => void
};

const TaskContext = createContext<ITaskContext>({
    task: null,
    template: null,
    updateTaskOverview: (task) => {},
    refreshTemplate: () => {}
});

const TaskProvider = TaskContext.Provider;
const TaskConsumer = TaskContext.Consumer;

const useTaskContext = () => useContext(TaskContext);

export default useTaskContext;
export { TaskContext, TaskConsumer, TaskProvider };
